<template>
  <div id="souzoku-wrapper">
    <h2 class="title">相続見積もりフォーム</h2>

    <div class="half-style left">
      <h3>１．相続人</h3>
    </div>

    <div class="half-style left">
      <div class="label-style">配偶者</div>
      <div>
        <md-radio name="haigusya" v-model="haigusya" md-value="無" class="md-primary">無</md-radio>
        <md-radio name="haigusya" v-model="haigusya" md-value="有" class="md-primary">有</md-radio>
      </div>
    </div>

    <div class="half-style left">
      <div class="label-style">子供</div>
      <div>
        <md-radio name="kodomo" v-model="kodomo" md-value="無" class="md-primary">無</md-radio>
        <md-radio name="kodomo" v-model="kodomo" md-value="有" class="md-primary">有</md-radio>
      </div>
    </div>

    <md-input-container class="half-style" v-show="kodomo !== '無'">
      <label>子供人数</label>
      <md-input v-model="kodomoNin" class="right" @input.native="validateNumber($event)"/>
      <span class="unit">人</span>
    </md-input-container>

    <div class="half-style left" v-show="kodomo === '無'">
      <div class="label-style">両親</div>
      <div>
        <md-radio name="ryoshin" v-model="ryoshin" md-value="無" class="md-primary">無</md-radio>
        <md-radio name="ryoshin" v-model="ryoshin" md-value="父及び母" class="md-primary">父及び母</md-radio>
        <md-radio name="ryoshin" v-model="ryoshin" md-value="父" class="md-primary">父</md-radio>
        <md-radio name="ryoshin" v-model="ryoshin" md-value="母" class="md-primary">母</md-radio>
      </div>
    </div>

    <div class="half-style left" v-show="kodomo === '無' && ryoshin === '無'">
      <div class="label-style">兄弟姉妹</div>
      <div>
        <md-radio name="ryoshin" v-model="kyodaiShimai" md-value="無" class="md-primary">無</md-radio>
        <md-radio name="ryoshin" v-model="kyodaiShimai" md-value="有" class="md-primary">有</md-radio>
      </div>
    </div>

    <md-input-container class="half-style" v-show="kodomo === '無' && ryoshin === '無'&& kyodaiShimai !== '無'">
      <label>兄弟姉妹人数</label>
      <md-input v-model="kyodaiShimaiNin" class="right" @input.native="validateNumber($event)"/>
      <span class="unit">人</span>
    </md-input-container>

    <div class="half-style left">
      <h3>２．財産</h3>
    </div>

    <div class="half-style left">
      <h4>土地(路線価)</h4>
    </div>
    <div class="half-style left zaisan-box">
      <md-input-container class="ken-style">
        <label>件数</label>
        <md-input v-model="tochiRosenkaKen" class="right" @input.native="validateNumber($event)"
                  @focus="manageComma('tochiRosenkaKen', true)" @blur="manageComma('tochiRosenkaKen', false)"/>
        <span class="unit">件</span>
      </md-input-container>
      <md-input-container class="gaku-style">
        <label>評価額</label>
        <md-input v-model="tochiRosenkaGaku" class="right" @input.native="validateNumber($event)"
                  @focus="manageComma('tochiRosenkaGaku', true)" @blur="manageComma('tochiRosenkaGaku', false)"/>
        <span class="unit">円</span>
      </md-input-container>
    </div>

    <div class="half-style left">
      <h4>土地(倍率)</h4>
    </div>
    <div class="half-style left zaisan-box">
      <md-input-container class="ken-style">
        <label>件数</label>
        <md-input v-model="tochiBairitsuKen" class="right" @input.native="validateNumber($event)"
                  @focus="manageComma('tochiBairitsuKen', true)" @blur="manageComma('tochiBairitsuKen', false)"/>
        <span class="unit">件</span>
      </md-input-container>
      <md-input-container class="gaku-style">
        <label>評価額</label>
        <md-input v-model="tochiBairitsuGaku" class="right" @input.native="validateNumber($event)"
                  @focus="manageComma('tochiBairitsuGaku', true)" @blur="manageComma('tochiBairitsuGaku', false)"/>
        <span class="unit">円</span>
      </md-input-container>
    </div>

    <div class="half-style left">
      <h4>建物</h4>
    </div>
    <div class="half-style left zaisan-box">
      <md-input-container class="ken-style">
        <label>件数</label>
        <md-input v-model="tatemonoKen" class="right" @input.native="validateNumber($event)"
                  @focus="manageComma('tatemonoKen', true)" @blur="manageComma('tatemonoKen', false)"/>
        <span class="unit">件</span>
      </md-input-container>
      <md-input-container class="gaku-style">
        <label>評価額</label>
        <md-input v-model="tatemonoGaku" class="right" @input.native="validateNumber($event)"
                  @focus="manageComma('tatemonoGaku', true)" @blur="manageComma('tatemonoGaku', false)"/>
        <span class="unit">円</span>
      </md-input-container>
    </div>

    <div class="half-style left">
      <h4>現金</h4>
    </div>
    <div class="half-style left zaisan-box">
      <div class="ken-style hidden-style"></div>
      <md-input-container class="gaku-style">
        <label>評価額</label>
        <md-input v-model="genkinGaku" class="right" @input.native="validateNumber($event)"
                  @focus="manageComma('genkinGaku', true)" @blur="manageComma('genkinGaku', false)"/>
        <span class="unit">円</span>
      </md-input-container>
    </div>

    <div class="half-style left">
      <h4>預金</h4>
    </div>
    <div class="half-style left zaisan-box">
      <md-input-container class="ken-style">
        <label>件数</label>
        <md-input v-model="yokinKen" class="right" @input.native="validateNumber($event)"
                  @focus="manageComma('yokinKen', true)" @blur="manageComma('yokinKen', false)"/>
        <span class="unit">件</span>
      </md-input-container>
      <md-input-container class="gaku-style">
        <label>評価額</label>
        <md-input v-model="yokinGaku" class="right" @input.native="validateNumber($event)"
                  @focus="manageComma('yokinGaku', true)" @blur="manageComma('yokinGaku', false)"/>
        <span class="unit">円</span>
      </md-input-container>
    </div>

    <div class="half-style left">
      <h4>生命保険金</h4>
    </div>
    <div class="half-style left zaisan-box">
      <md-input-container class="ken-style">
        <label>件数</label>
        <md-input v-model="seimeihokenKen" class="right" @input.native="validateNumber($event)"
                  @focus="manageComma('seimeihokenKen', true)" @blur="manageComma('seimeihokenKen', false)"/>
        <span class="unit">件</span>
      </md-input-container>
      <md-input-container class="gaku-style">
        <label>評価額</label>
        <md-input v-model="seimeihokenGaku" class="right" @input.native="validateNumber($event)"
                  @focus="manageComma('seimeihokenGaku', true)" @blur="manageComma('seimeihokenGaku', false)"/>
        <span class="unit">円</span>
      </md-input-container>
    </div>

    <div class="half-style left">
      <h4>生保権利</h4>
    </div>
    <div class="half-style left zaisan-box">
      <md-input-container class="ken-style">
        <label>件数</label>
        <md-input v-model="seihokenriKen" class="right" @input.native="validateNumber($event)"
                  @focus="manageComma('seihokenriKen', true)" @blur="manageComma('seihokenriKen', false)"/>
        <span class="unit">件</span>
      </md-input-container>
      <md-input-container class="gaku-style">
        <label>評価額</label>
        <md-input v-model="seihokenriGaku" class="right" @input.native="validateNumber($event)"
                  @focus="manageComma('seihokenriGaku', true)" @blur="manageComma('seihokenriGaku', false)"/>
        <span class="unit">円</span>
      </md-input-container>
    </div>

    <div class="half-style left">
      <h4>贈与財産</h4>
    </div>
    <div class="half-style left zaisan-box">
      <md-input-container class="ken-style">
        <label>件数</label>
        <md-input v-model="zoyozaisanKen" class="right" @input.native="validateNumber($event)"
                  @focus="manageComma('zoyozaisanKen', true)" @blur="manageComma('zoyozaisanKen', false)"/>
        <span class="unit">件</span>
      </md-input-container>
      <md-input-container class="gaku-style">
        <label>評価額</label>
        <md-input v-model="zoyozaisanGaku" class="right" @input.native="validateNumber($event)"
                  @focus="manageComma('zoyozaisanGaku', true)" @blur="manageComma('zoyozaisanGaku', false)"/>
        <span class="unit">円</span>
      </md-input-container>
    </div>

    <div class="half-style left">
      <h4>その他</h4>
    </div>
    <div class="half-style left zaisan-box">
      <md-input-container class="ken-style">
        <label>件数</label>
        <md-input v-model="sonotaKen" class="right" @input.native="validateNumber($event)"
                  @focus="manageComma('sonotaKen', true)" @blur="manageComma('sonotaKen', false)"/>
        <span class="unit">件</span>
      </md-input-container>
      <md-input-container class="gaku-style">
        <label>評価額</label>
        <md-input v-model="sonotaGaku" class="right" @input.native="validateNumber($event)"
                  @focus="manageComma('sonotaGaku', true)" @blur="manageComma('sonotaGaku', false)"/>
        <span class="unit">円</span>
      </md-input-container>
    </div>

    <div class="half-style left">
      <h3>３．債務・葬式費用</h3>
    </div>

    <div class="half-style left">
      <h4>借入金</h4>
    </div>
    <div class="half-style left zaisan-box">
      <md-input-container class="ken-style">
        <label>件数</label>
        <md-input v-model="kariirekinKen" class="right" @input.native="validateNumber($event)"
                  @focus="manageComma('kariirekinKen', true)" @blur="manageComma('kariirekinKen', false)"/>
        <span class="unit">件</span>
      </md-input-container>
      <md-input-container class="gaku-style">
        <label>債務金額</label>
        <md-input v-model="kariirekinGaku" class="right" @input.native="validateNumber($event)"
                  @focus="manageComma('kariirekinGaku', true)" @blur="manageComma('kariirekinGaku', false)"/>
        <span class="unit">円</span>
      </md-input-container>
    </div>

    <div class="half-style left">
      <h4>葬式費用</h4>
    </div>
    <div class="half-style left zaisan-box">
      <div class="ken-style hidden-style"></div>
      <md-input-container class="gaku-style">
        <label>債務金額</label>
        <md-input v-model="sosikihiyouGaku" class="right" @input.native="validateNumber($event)"
                  @focus="manageComma('sosikihiyouGaku', true)" @blur="manageComma('sosikihiyouGaku', false)"/>
        <span class="unit">円</span>
      </md-input-container>
    </div>

    <div class="half-style left">
      <h4>未払税金</h4>
    </div>
    <div class="half-style left zaisan-box">
      <md-input-container class="ken-style">
        <label>件数</label>
        <md-input v-model="mibaraizeiKen" class="right" @input.native="validateNumber($event)"
                  @focus="manageComma('mibaraizeiKen', true)" @blur="manageComma('mibaraizeiKen', false)"/>
        <span class="unit">件</span>
      </md-input-container>
      <md-input-container class="gaku-style">
        <label>債務金額</label>
        <md-input v-model="mibaraizeiGaku" class="right" @input.native="validateNumber($event)"
                  @focus="manageComma('mibaraizeiGaku', true)" @blur="manageComma('mibaraizeiGaku', false)"/>
        <span class="unit">円</span>
      </md-input-container>
    </div>

    <div class="half-style left">
      <h4>未払医療費等</h4>
    </div>
    <div class="half-style left zaisan-box">
      <md-input-container class="ken-style">
        <label>件数</label>
        <md-input v-model="mibaraiiryohiKen" class="right" @input.native="validateNumber($event)"
                  @focus="manageComma('mibaraiiryohiKen', true)" @blur="manageComma('mibaraiiryohiKen', false)"/>
        <span class="unit">件</span>
      </md-input-container>
      <md-input-container class="gaku-style">
        <label>債務金額</label>
        <md-input v-model="mibaraiiryohiGaku" class="right" @input.native="validateNumber($event)"
                  @focus="manageComma('mibaraiiryohiGaku', true)" @blur="manageComma('mibaraiiryohiGaku', false)"/>
        <span class="unit">円</span>
      </md-input-container>
    </div>

    <div class="half-style left">
      <h3>４．個別事案</h3>
    </div>

    <div class="half-style left">
      <h4>小規模宅地等</h4>
    </div>
    <div class="half-style left zaisan-box">
      <md-input-container>
        <label>件数</label>
        <md-input v-model="syokibotakuchiKen" class="right" @input.native="validateNumber($event)"
                  @focus="manageComma('syokibotakuchiKen', true)" @blur="manageComma('syokibotakuchiKen', false)"/>
        <span class="unit">件</span>
      </md-input-container>
    </div>

    <template v-for="index in asNum(syokibotakuchiKen) < 100 ? asNum(syokibotakuchiKen) : 100">
      <div class="half-style left zaisan-box" :key="index">
        <md-input-container>
          <label for="syokibotakuchiYoto">用途</label>
          <md-select name="syokibotakuchiYoto" id="syokibotakuchiYoto" v-model="syokibotakuchiYoto[index]">
            <md-option value="該当なし">該当なし</md-option>
            <md-option value="特定居住用宅地等">特定居住用宅地等</md-option>
            <md-option value="特定事業用宅地等">特定事業用宅地等</md-option>
            <md-option value="貸付事業用宅地等">貸付事業用宅地等</md-option>
            <md-option value="特定同族会社宅地等">特定同族会社宅地等</md-option>
          </md-select>
        </md-input-container>
      </div>
      <div class="half-style left zaisan-box">
        <md-input-container class="ken-style">
          <label>面積</label>
          <md-input v-model="syokibotakuchiMenseki[index]" class="right" @input.native="validateNumber($event)"
                    @focus="manageArrayComma('syokibotakuchiMenseki', index, true)"
                    @blur="manageArrayComma('syokibotakuchiMenseki', index, false)"/>
          <span class="unit">㎡</span>
        </md-input-container>
        <md-input-container class="gaku-style">
          <label>固定資産税評価額</label>
          <md-input v-model="syokibotakuchiGaku[index]" class="right" @input.native="validateNumber($event)"
                    @focus="manageArrayComma('syokibotakuchiGaku', index, true)"
                    @blur="manageArrayComma('syokibotakuchiGaku', index, false)"/>
          <span class="unit">円</span>
        </md-input-container>
      </div>
    </template>

    <div class="half-style left">
      <h4>広大地</h4>
    </div>
    <div class="half-style left zaisan-box">
      <md-input-container class="ken-style">
        <label>件数</label>
        <md-input v-model="kodaichiKen" class="right" @input.native="validateNumber($event)"
                  @focus="manageComma('kodaichiKen', true)" @blur="manageComma('kodaichiKen', false)"/>
        <span class="unit">件</span>
      </md-input-container>
      <md-input-container class="gaku-style">
        <label>評価額</label>
        <md-input v-model="kodaichiGaku" class="right" @input.native="validateNumber($event)"
                  @focus="manageComma('kodaichiGaku', true)" @blur="manageComma('kodaichiGaku', false)"/>
        <span class="unit">円</span>
      </md-input-container>
    </div>

    <div class="half-style left">
      <h4>非上場株式</h4>
    </div>
    <div class="half-style left zaisan-box">
      <md-input-container class="ken-style">
        <label>件数</label>
        <md-input v-model="hijoujoukabushikiKen" class="right" @input.native="validateNumber($event)"
                  @focus="manageComma('hijoujoukabushikiKen', true)"
                  @blur="manageComma('hijoujoukabushikiKen', false)"/>
        <span class="unit">件</span>
      </md-input-container>
      <md-input-container class="gaku-style">
        <label>評価額</label>
        <md-input v-model="hijoujoukabushikiGaku" class="right" @input.native="validateNumber($event)"
                  @focus="manageComma('hijoujoukabushikiGaku', true)"
                  @blur="manageComma('hijoujoukabushikiGaku', false)"/>
        <span class="unit">円</span>
      </md-input-container>
    </div>

    <div class="half-style left">
      <h4>配偶者相続分</h4>
    </div>
    <div class="half-style left zaisan-box">
      <div class="ken-style hidden-style"></div>
      <md-input-container class="gaku-style">
        <label>評価額</label>
        <md-input v-model="haigusyasouzokubunGaku" class="right" @input.native="validateNumber($event)"
                  @focus="manageComma('haigusyasouzokubunGaku', true)"
                  @blur="manageComma('haigusyasouzokubunGaku', false)"/>
        <span class="unit">円</span>
      </md-input-container>
    </div>

    <div id="shiharai-sogaku">
      <div class="mid-text">相続税報酬</div>
      {{hosyuGokei.toLocaleString()}}円
      <span class="mid-text">(税抜)</span>
    </div>

    <div id="gaisan-sogaku">
      <div class="mid-small-text">概算相続税額</div>
      {{gokeiSouzokuZeiGakuKei > 0 ? gokeiSouzokuZeiGakuKei.toLocaleString() + '円' : '納付税額はありません。'}}
    </div>

    <md-button class="mitsumori-button md-raised md-primary" v-show="!isShowing" @click="toggleShow">
      御見積書表示
    </md-button>
    <md-button class="mitsumori-button md-raised md-primary" v-show="isShowing" @click="toggleShow">
      御見積書非表示
    </md-button>

    <div v-show="isShowing" id="mitsumori-syo-wrapper">
      <div id="mitsumori-syo">
        <div id="mitsumori-title">御見積書</div>
        <div id="mitsumori-client-wrapper">
          <div id="mitsumori-client">
            <span id="mitsumori-name">WEB訪問者</span>
            <span id="mitsumori-sama">様</span>
          </div>
        </div>
        <div id="mitsumori-contact-wrapper">
          <div id="mitsumori-contact">
            〒355-0027<br>
            埼玉県東松山市美土里町6-67<br>
            服部税理士事務所<br>
            TEL 0493-81-6162<br>
            FAX 0493-81-6163<br>
          </div>
        </div>
        <div id="mitsumori-cost-wrapeer">
          下記の通りお見積もり申し上げます。
          <table id="mitsumori-cost-table" cellspacing="0">
            <tr>
              <td id="mitsumori-cost-title">お見積もり金額 <br>（消費税込）</td>
              <td id="mitsumori-cost">{{mitsumoriGokei.toLocaleString() + ' 円'}}</td>
            </tr>
          </table>
        </div>
        <div class="left">見積明細</div>
        <table id="mitsumori-table" cellspacing="0">
          <tr>
            <th>内容</th>
            <th>数量</th>
            <th>単位</th>
            <th>単価</th>
            <th>金額</th>
          </tr>
          <tr>
            <td>基本報酬</td>
            <td class="right">1</td>
            <td>申告</td>
            <td class="right">{{kihonHosyu.toLocaleString()}}</td>
            <td class="right">{{kihonHosyu.toLocaleString()}}</td>
          </tr>
          <tr>
            <td>相続評価額加算報酬</td>
            <td class="right" colspan="2">{{hyokagakuGokei.toLocaleString()}} 円</td>
            <td class="right">{{isangakuKasanRitsu * 100}}%</td>
            <td class="right">{{mitsumoriKingaku2.toLocaleString()}}</td>
          </tr>
          <tr v-if="asNum(tochiRosenkaKen) > 0">
            <td>土地加算額（路線価）</td>
            <td class="right">{{tochiRosenkaKen}}</td>
            <td>件</td>
            <td class="right">{{tochiKasanRosenkaTanka.toLocaleString()}}</td>
            <td class="right">{{tochiKasanRosenkaHosyu.toLocaleString()}}</td>
          </tr>
          <tr v-if="asNum(tochiBairitsuKen) > 0">
            <td>土地加算額（路線価）</td>
            <td class="right">{{tochiBairitsuKen}}</td>
            <td>件</td>
            <td class="right">{{tochiKasanBairitsuTanka.toLocaleString()}}</td>
            <td class="right">{{tochiKasanBairitsuHosyu.toLocaleString()}}</td>
          </tr>
          <tr v-if="asNum(haigusyasouzokubunGaku) > 0">
            <td>配偶者特別控除</td>
            <td class="right">1</td>
            <td>件</td>
            <td class="right">{{haigusyaTokubetsukojoHosyu.toLocaleString()}}</td>
            <td class="right">{{haigusyaTokubetsukojoHosyu.toLocaleString()}}</td>
          </tr>
          <tr v-if="asNum(syokibotakuchiKen) > 0">
            <td>小規模宅地等</td>
            <td class="right">1</td>
            <td>件</td>
            <td class="right">{{syokibotakuchiHosyu.toLocaleString()}}</td>
            <td class="right">{{syokibotakuchiHosyu.toLocaleString()}}</td>
          </tr>
          <tr v-if="asNum(hijoujoukabushikiKen) > 0">
            <td>非上場株式（基本報酬10万円）</td>
            <td class="right">0.5%</td>
            <td>件</td>
            <td class="right">{{hijoujoukabushikiGaku.toLocaleString()}}</td>
            <td class="right">{{hijoujouKabushikiHosyu.toLocaleString()}}</td>
          </tr>
          <tr v-if="asNum(kodaichiKen) > 0">
            <td>広大地　基本報酬</td>
            <td class="right">{{kodaichiKen}}</td>
            <td>件</td>
            <td class="right">{{'100,000'}}</td>
            <td class="right">{{kodaichiHosyu.toLocaleString()}}</td>
          </tr>
          <tr v-if="asNum(kodaichiKen) > 0">
            <td>上　記　加算報酬　税額減</td>
            <td class="right"></td>
            <td></td>
            <td class="right">{{'10％'}}</td>
            <td class="right"></td>
          </tr>
          <tr v-for="_ in Array(4)">
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
          </tr>
          <tr>
            <td class="mitsumori-kei" colspan="4">小計</td>
            <td class="right">{{mitsumoriSyokei.toLocaleString()}}</td>
          </tr>
          <tr>
            <td class="mitsumori-kei" colspan="4">消費税</td>
            <td class="right">{{mitsumoriZei.toLocaleString()}}</td>
          </tr>
          <tr>
            <td class="mitsumori-kei" colspan="4">合計</td>
            <td class="right">{{mitsumoriGokei.toLocaleString()}}</td>
          </tr>
        </table>
        <md-button id="mitsumori-print-button" class="mitsumori-button md-raised" v-show="isShowing"
                   @click="print">
          印刷
        </md-button>
      </div>
    </div>

  </div>
</template>

<script>
  import Vue from 'vue'

  function asNum(str) {
    if (!str) {
      return 0
    }
    return Number(str.replace(/,/g, ''))
  }

  export default {
    name : 'Mitsumori',
    components : {},
    data() {
      return {
        haigusya : '無',
        kodomo : '無',
        kodomoNin : '',
        ryoshin : '無',
        kyodaiShimai : '無',
        kyodaiShimaiNin : '',

        tochiRosenkaKen : '',
        tochiRosenkaGaku : '',
        tochiBairitsuKen : '',
        tochiBairitsuGaku : '',
        tatemonoKen : '',
        tatemonoGaku : '',
        genkinGaku : '',
        yokinKen : '',
        yokinGaku : '',
        seimeihokenKen : '',
        seimeihokenGaku : '',
        seihokenriKen : '',
        seihokenriGaku : '',
        zoyozaisanKen : '',
        zoyozaisanGaku : '',
        sonotaKen : '',
        sonotaGaku : '',

        kariirekinKen : '',
        kariirekinGaku : '',
        sosikihiyouGaku : '',
        mibaraizeiKen : '',
        mibaraizeiGaku : '',
        mibaraiiryohiKen : '',
        mibaraiiryohiGaku : '',

        syokibotakuchiKen : '',
        syokibotakuchiYoto : [''],
        syokibotakuchiMenseki : [''],
        syokibotakuchiGaku : [''],
        kodaichiKen : '',
        kodaichiGaku : '',
        hijoujoukabushikiKen : '',
        hijoujoukabushikiGaku : '',
        haigusyasouzokubunGaku : '',

        isShowing : false
      }
    },
    computed : {
      mitsumoriKingaku2 : function () {
        return ExcelUtils.rounddown(this.hyokagakuGokei * this.isangakuKasanRitsu - this.isanKoujoGaku, -3)
      },
      // 見積書小計
      mitsumoriSyokei : function () {
        var syokei = 0
        syokei += this.kihonHosyu
        syokei += this.mitsumoriKingaku2
        syokei += this.tochiKasanRosenkaHosyu
        syokei += this.tochiKasanBairitsuHosyu
        syokei += this.haigusyaTokubetsukojoHosyu
        syokei += this.syokibotakuchiHosyu
        syokei += this.hijoujouKabushikiHosyu
        syokei += this.kodaichiHosyu
        return syokei
      },
      // 見積書税
      mitsumoriZei : function () {
        return this.mitsumoriSyokei * 0.08
      },
      // 見積書合計
      mitsumoriGokei : function () {
        return this.mitsumoriSyokei + this.mitsumoriZei
      },
      // R148
      souzokuHaigusyaSu : function () {
        return this.haigusya === '無' ? 0 : 1
      },
      // R149
      souzokuKodomoSu : function () {
        return this.kodomo === '無' ? 0 : asNum(this.kodomoNin)
      },
      // R150
      souzokuRyoshinSu : function () {
        return this.kodomo === '有' || this.ryoshin === '無' ?
          0 : this.ryoshin === '父及び母' ? 2 : 1
      },
      // R151
      souzokuKyodaiShimaiSu : function () {
        return this.kodomo === '有' || this.ryoshin === '有' || this.kyodaiShimai === '無' ?
          0 : asNum(this.kyodaiShimaiNin)
      },
      // R152
      souzokuNinZu : function () {
        return this.souzokuHaigusyaSu + this.souzokuKodomoSu + this.souzokuRyoshinSu + this.souzokuKyodaiShimaiSu
      },
      // T157
      kisoKojo : function () {
        return kisoKojo(this.souzokuNinZu)
      },
      // I54
      hyokagakuGokei : function () {
        return asNum(this.tochiRosenkaGaku) + asNum(this.tochiBairitsuGaku) + asNum(this.tatemonoGaku) + asNum(this.genkinGaku) + asNum(this.yokinGaku)
          + asNum(this.seimeihokenGaku) + asNum(this.seihokenriGaku) + asNum(this.zoyozaisanGaku) + asNum(this.sonotaGaku)
      },
      // I70
      saimuGokei : function () {
        return asNum(this.kariirekinGaku) + asNum(this.sosikihiyouGaku) + asNum(this.mibaraizeiGaku) + asNum(this.mibaraiiryohiGaku)
      },
      // M171, M175, M179, M183
      syokiboTakuchiKoujoMenseki : function () {
        var syokiboTakuchiKoujoMensekiArray = []
        for (var i = 0; i < this.syokibotakuchiYoto.length; i++) {
          syokiboTakuchiKoujoMensekiArray.push(syokiboTakuchiKoujoMenseki(this.syokibotakuchiYoto[i]))
        }
        return syokiboTakuchiKoujoMensekiArray
      },
      // W171, W175, W179, W183
      syokiboTakuchiWariai : function () {
        var syokiboTakuchiWariaiArray = []
        for (var i = 0; i < this.syokiboTakuchiKoujoMenseki.length; i++) {
          syokiboTakuchiWariaiArray.push(syokiboTakuchiWariai(this.syokiboTakuchiKoujoMenseki[i]))
        }
        return syokiboTakuchiWariaiArray
      },
      // X173, X177, X181, X185
      syokiboTakuchiHyokagen : function () {
        var syokiboTakuchiHyokagenArray = []
        for (var i = 0; i < this.syokibotakuchiYoto.length; i++) {
          syokiboTakuchiHyokagenArray.push(syokiboTakuchiHyokagen(
            this.syokiboTakuchiKoujoMenseki[i], this.syokiboTakuchiWariai[i],
            asNum(this.syokibotakuchiMenseki[i]), asNum(this.syokibotakuchiGaku[i])
          ))
        }
        return syokiboTakuchiHyokagenArray
      },
      // X187
      syokiboTakuchiHyokagenGokei : function () {
        var gokei = 0
        for (var i = 0; i < this.syokiboTakuchiHyokagen.length; i++) {
          gokei += this.syokiboTakuchiHyokagen[i]
        }
        return gokei
      },
      // T165
      seimeihokenNoHikazei : function () {
        return seimeihokenNoHikazei(this.souzokuNinZu)
      },
      // AA165
      zaisankaraKoujoSuruGaku : function () {
        return zaisankaraKoujoSuruGaku(asNum(this.seimeihokenGaku), this.seimeihokenNoHikazei)
      },
      // X168
      kazeiZaisan : function () {
        return kazeiZaisan(this.hyokagakuGokei, this.zaisankaraKoujoSuruGaku, this.syokiboTakuchiHyokagenGokei, this.saimuGokei)
      },
      // W192
      sashihikiKazeiKakaku : function () {
        return sashihikiKazeiKakaku(this.kazeiZaisan, this.kisoKojo)
      },
      // E194
      haigusyaHouteiSouzokuBun : function () {
        return haigusyaHouteiSouzokuBun(this.souzokuHaigusyaSu, this.souzokuKodomoSu, this.souzokuRyoshinSu, this.souzokuKyodaiShimaiSu)
      },
      // E195
      kodomoHouteiSouzokuBun : function () {
        return kodomoHouteiSouzokuBun(this.souzokuHaigusyaSu, this.souzokuKodomoSu, this.souzokuRyoshinSu, this.souzokuKyodaiShimaiSu)
      },
      // E196
      ryoshinHouteiSouzokuBun : function () {
        return ryoshinHouteiSouzokuBun(this.souzokuHaigusyaSu, this.souzokuKodomoSu, this.souzokuRyoshinSu, this.souzokuKyodaiShimaiSu)
      },
      // E197
      kyodaiShimaiHouteiSouzokuBun : function () {
        return kyodaiShimaiHouteiSouzokuBun(this.souzokuHaigusyaSu, this.souzokuKodomoSu, this.souzokuRyoshinSu, this.souzokuKyodaiShimaiSu)
      },
      // E198
      gokeiHouteiSouzokuBun : function () {
        return this.haigusyaHouteiSouzokuBun
          + this.kodomoHouteiSouzokuBun * this.souzokuKodomoSu
          + this.ryoshinHouteiSouzokuBun * this.souzokuRyoshinSu
          + this.kyodaiShimaiHouteiSouzokuBun * this.souzokuKyodaiShimaiSu
      },
      // M194
      haigusyaKazeikakaku : function () {
        return ExcelUtils.rounddown(this.haigusyaHouteiSouzokuBun * this.sashihikiKazeiKakaku, -3)
      },
      // M195
      kodomoKazeikakaku : function () {
        return ExcelUtils.rounddown(this.kodomoHouteiSouzokuBun * this.sashihikiKazeiKakaku, -3)
      },
      // M196
      ryoshinKazeikakaku : function () {
        return ExcelUtils.rounddown(this.ryoshinHouteiSouzokuBun * this.sashihikiKazeiKakaku, -3)
      },
      // M197
      kyodaiShimaiKazeikakaku : function () {
        return ExcelUtils.rounddown(this.kyodaiShimaiHouteiSouzokuBun * this.sashihikiKazeiKakaku, -3)
      },
      // M198
      gokeiKazeikakaku : function () {
        return this.haigusyaKazeikakaku
          + this.kodomoKazeikakaku * this.souzokuKodomoSu
          + this.ryoshinKazeikakaku * this.souzokuRyoshinSu
          + this.kyodaiShimaiKazeikakaku * this.souzokuKyodaiShimaiSu
      },
      // W194
      haigusyaSouzokuZeiGaku : function () {
        return souzokuZeiGaku(this.haigusyaKazeikakaku, this.souzokuHaigusyaSu)
      },
      // W195
      kodomoSouzokuZeiGaku : function () {
        return souzokuZeiGaku(this.kodomoKazeikakaku, this.souzokuKodomoSu)
      },
      // W196
      ryoshinSouzokuZeiGaku : function () {
        return souzokuZeiGaku(this.ryoshinKazeikakaku, this.souzokuRyoshinSu)
      },
      // W197
      kyodaiShimaiSouzokuZeiGaku : function () {
        return souzokuZeiGaku(this.kyodaiShimaiKazeikakaku, this.souzokuKyodaiShimaiSu)
      },
      // W198
      gokeiSouzokuZeiGaku : function () {
        return gokeiSouzokuZeiGaku(this.haigusyaSouzokuZeiGaku, this.kodomoSouzokuZeiGaku, this.ryoshinSouzokuZeiGaku, this.kyodaiShimaiSouzokuZeiGaku)
      },
      // I215
      haigusyaSyutokuzaisan : function () {
        return asNum(this.haigusyasouzokubunGaku)
      },
      // N215
      kodomoSyutokuzaisan : function () {
        return syutokuzaisan(this.kazeiZaisan, this.haigusyaSyutokuzaisan, this.souzokuKodomoSu)
      },
      // R215
      ryoshinSyutokuzaisan : function () {
        return syutokuzaisan(this.kazeiZaisan, this.haigusyaSyutokuzaisan, this.souzokuRyoshinSu)
      },
      // V215
      kyodaiShimaiSyutokuzaisan : function () {
        return syutokuzaisan(this.kazeiZaisan, this.haigusyaSyutokuzaisan, this.souzokuKyodaiShimaiSu)
      },
      // I216
      haigusyaAnbunWariai : function () {
        return this.kazeiZaisan === 0 ? 0 : this.haigusyaSyutokuzaisan / this.kazeiZaisan
      },
      // N216
      kodomoAnbunWariai : function () {
        return this.kazeiZaisan === 0 ? 0 : this.kodomoSyutokuzaisan / this.kazeiZaisan
      },
      // R216
      ryoshinAnbunWariai : function () {
        return this.kazeiZaisan === 0 ? 0 : this.ryoshinSyutokuzaisan / this.kazeiZaisan
      },
      // V216
      kyodaiShimaiAnbunWariai : function () {
        return this.kazeiZaisan === 0 ? 0 : this.kyodaiShimaiSyutokuzaisan / this.kazeiZaisan
      },
      // I217
      haigusyaAnbunZeigaku : function () {
        return this.haigusyaAnbunWariai * this.gokeiSouzokuZeiGaku
      },
      // N217
      kodomoAnbunZeigaku : function () {
        return this.kodomoAnbunWariai * this.gokeiSouzokuZeiGaku
      },
      // R217
      ryoshinAnbunZeigaku : function () {
        return this.ryoshinAnbunWariai * this.gokeiSouzokuZeiGaku
      },
      // V217
      kyodaiShimaiAnbunZeigaku : function () {
        return this.kyodaiShimaiAnbunWariai * this.gokeiSouzokuZeiGaku
      },
      // I218
      haigusyaTokubetsuKojo : function () {
        return haigusyaTokubetsuKojo(this.haigusyaAnbunZeigaku, this.gokeiSouzokuZeiGaku)
      },
      // I220
      haigusyaSouzokuZeiGakuKei : function () {
        return this.haigusyaAnbunZeigaku + this.haigusyaTokubetsuKojo
      },
      // N220
      kodomoSouzokuZeiGakuKei : function () {
        return ExcelUtils.rounddown(this.kodomoAnbunZeigaku, -2)
      },
      // R220
      ryoshinSouzokuZeiGakuKei : function () {
        return ExcelUtils.rounddown(this.ryoshinAnbunZeigaku, -2)
      },
      // V220
      kyodaiShimaiSouzokuZeiGakuKei : function () {
        return ExcelUtils.rounddown(this.kyodaiShimaiAnbunZeigaku, -2)
      },
      // Z220
      gokeiSouzokuZeiGakuKei : function () {
        return this.haigusyaSouzokuZeiGakuKei
          + this.kodomoSouzokuZeiGakuKei * this.souzokuKodomoSu
          + this.ryoshinSouzokuZeiGakuKei * this.souzokuRyoshinSu
          + this.kyodaiShimaiSouzokuZeiGakuKei * this.souzokuKyodaiShimaiSu
      },
      // V236
      isangakuKasanRitsu : function () {
        return isangakuKasanRitsu(this.gokeiSouzokuZeiGakuKei, this.kazeiZaisan)
      },
      // Y262
      isanKoujoGaku : function () {
        return isanKoujoGaku(this.kazeiZaisan)
      },
      // I234
      kihonHosyu : function () {
        return kihonHosyu()
      },
      // I236
      isangakuKasanHosyu : function () {
        return isangakuKasanHosyu(this.hyokagakuGokei, this.saimuGokei, this.isangakuKasanRitsu, this.isanKoujoGaku)
      },
      // X238
      tochiKasanRosenkaTanka : function () {
        return tochiKasanRosenkaTanka(this.gokeiSouzokuZeiGakuKei)
      },
      // I238
      tochiKasanRosenkaHosyu : function () {
        return tochiKasanRosenkaHosyu(this.tochiKasanRosenkaTanka, asNum(this.tochiRosenkaKen))
      },
      // X240
      tochiKasanBairitsuTanka : function () {
        return tochiKasanBairitsuTanka(this.gokeiSouzokuZeiGakuKei)
      },
      // I240
      tochiKasanBairitsuHosyu : function () {
        return tochiKasanBairitsuHosyu(this.tochiKasanBairitsuTanka, asNum(this.tochiBairitsuKen))
      },
      // I242
      haigusyaTokubetsukojoHosyu : function () {
        return haigusyaTokubetsukojoHosyu(asNum(this.haigusyasouzokubunGaku))
      },
      // I244
      hijoujouKabushikiHosyu : function () {
        return hijoujouKabushikiHosyu(asNum(this.hijoujoukabushikiKen), asNum(this.hijoujoukabushikiGaku))
      },
      // I246
      syokibotakuchiHosyu : function () {
        return syokibotakuchiHosyu(asNum(this.syokibotakuchiKen))
      },
      // I248
      kodaichiHosyu : function () {
        return kodaichiHosyu(asNum(this.kodaichiKen))
      },
      // I250
      zippiHosyu : function () {
        return zippiHosyu(asNum(this.tochiRosenkaKen), asNum(this.tatemonoKen), this.souzokuNinZu)
      },
      // I252
      hosyuGokei : function () {
        return hosyuGokei(
          this.kihonHosyu, this.isangakuKasanHosyu, this.tochiKasanRosenkaHosyu, this.tochiKasanBairitsuHosyu,
          this.haigusyaTokubetsukojoHosyu, this.hijoujouKabushikiHosyu, this.syokibotakuchiHosyu, this.kodaichiHosyu, this.zippiHosyu
        )
      }
    },
    methods : {
      asNum : function (str) {
        return Number(str.replace(/,/g, ''))
      },
      validateNumber : function (event) {
        if (event.inputType === 'insertCompositionText') {
          return
        }

        // 全角 → 半角、数値以外を除外
        event.target.value = event.target.value.replace(/[０-９]/g, function (s) {return String.fromCharCode(s.charCodeAt(0) - 65248)}).replace(/[^0-9]/g, '')
      },
      manageComma : function (key, hasFocus) {
        // コンマ追加、削除
        if (hasFocus) {
          // this[key] = this[key].replace(/,/g, '')
        } else {
          this[key] = this[key] ? Number(this[key].replace(/[^0-9]/g, '').replace(/,/g, '')).toLocaleString() : this[key]
        }
      },
      manageArrayComma : function (key, index, hasFocus) {
        // コンマ追加、削除
        if (hasFocus) {
          // this[key] = this[key].replace(/,/g, '')
        } else {
          Vue.set(this[key], index, this[key][index] ? Number(this[key][index].replace(/[^0-9]/g, '').replace(/,/g, '')).toLocaleString() : this[key][index])
        }
      },
      toggleShow : function () {
        this.isShowing = !this.isShowing

        if (this.isShowing) {
          // 見積書までスクロール
          setTimeout(function () {
            var y = document.getElementById('mitsumori-syo-wrapper')
              .getBoundingClientRect().top + window.scrollY - 32
            window.scroll({top : y, behavior : 'smooth'})
          }, 100)
        }
      },
      print : function () {
        var el = '#mitsumori-syo-wrapper'
        var iframe = document.createElement('IFRAME')
        var doc = null
        $(iframe).attr('style', 'position:absolute;width:0px;height:0px;left:-500px;top:-500px;')
        // $(iframe).attr('style', 'position:absolute;width:1000px;height:500px;left:0px;top:0px;')
        document.body.appendChild(iframe)
        doc = iframe.contentWindow.document
        doc.write('<div class="' + $(el).attr('class') + '">' + $(el).html() + '</div>')
        $('body', doc)[0].style.webkitPrintColorAdjust = 'exact'
        $('body', doc)[0].style.colorAdjust = 'exact'

        $('#mitsumori-print-button', doc).remove()

        // Styleをコピー
        var parentStyleSheets = document.styleSheets
        var cssString = ''
        for (var i = 0; i < parentStyleSheets.length; i++) {
          if (parentStyleSheets[i].cssRules) {
            var cssRules = parentStyleSheets[i].cssRules
            for (var j = 0; j < cssRules.length; j++)
              cssString += cssRules[j].cssText
          } else {
            cssString += parentStyleSheets[i].cssText
          }
        }
        var style = doc.createElement('style')
        style.type = 'text/css'
        style.innerHTML = cssString
        doc.getElementsByTagName('head')[0].appendChild(style)

        doc.close()
        iframe.contentWindow.focus()
        setTimeout(function () {
          iframe.contentWindow.print()
          setTimeout(function () {
            document.body.removeChild(iframe)
          }, 100)
        }, 100)
      }
    }
  }
</script>


<style scoped>
  input[type=text] {
    font-size : 16px;
  }

  #souzoku-wrapper {
    color            : #0B0B61;
    display          : flex;
    flex-flow        : column;
    align-items      : center;
    justify-content  : center;
    width            : 60%;
    margin           : auto;
    background-color : white;
    border-radius    : 4px;
    box-shadow       : 1px 1px 4px gray;
  }

  @media screen and (max-width : 1024px) {
    #souzoku-wrapper {
      width : 90%;
    }
  }

  .title {
    margin        : 32px 0;
    padding       : 8px 48px;
    border-bottom : 1px #D4E6FF solid;
  }

  .label-style {
    font-size : 12px;
    color     : rgba(0, 0, 0, 0.54);
  }

  .half-style {
    width     : 50%;
    max-width : 50%;
  }

  .sub-content {
    margin-left : 4%;
    width       : 46%;
  }

  .zaisan-box {
    display : flex;
  }

  .ken-style {
    width     : 30%;
    max-width : 30%;
  }

  .gaku-style {
    width       : 66%;
    max-width   : 66%;
    margin-left : 4%;
  }

  .hidden-style {
    visibility : hidden;
  }

  @media screen and (max-width : 1024px) {
    .title {
      padding : 8px 16px;
    }

    .half-style {
      width     : 80%;
      max-width : 80%;
    }

    .sub-content {
      margin-left : 8%;
      width       : 72%;
    }
  }

  .unit {
    padding : 6px;
  }

  .right {
    text-align : right !important;
  }

  .left {
    text-align : left !important;
  }

  .center {
    text-align : center !important;
  }

  .warn-text {
    color : red;
  }

  #shiharai-sogaku {
    width            : 50%;
    font-size        : 36px;
    line-height      : 36px;
    padding          : 12px 24px 8px 24px;
    border-top       : 1px #0B0B61 solid;
    border-bottom    : 1px #0B0B61 solid;
    background-color : #EAF2FF;
  }

  #gaisan-sogaku {
    color            : rgba(11, 11, 97, 0.7);
    width            : 50%;
    font-size        : 24px;
    line-height      : 32px;
    margin-top       : 12px;
    padding          : 12px 24px 8px 24px;
    border-top       : 1px rgba(11, 11, 97, 0.8) solid;
    border-bottom    : 1px rgba(11, 11, 97, 0.8) solid;
    background-color : #FFFFFF;
  }

  @media screen and (max-width : 1024px) {
    #shiharai-sogaku {
      width : 90%;
    }

    #gaisan-sogaku {
      width : 90%;
    }
  }

  .mid-text {
    font-size : 24px;
  }

  .mid-small-text {
    font-size : 20px;
  }

  .small-text {
    font-size : 16px;
  }

  .mitsumori-button {
    margin    : 24px 32px;
    font-size : 16px;
  }

  #mitsumori-syo-wrapper {
    margin-top : 32px;
    width      : 90%;
    overflow-x : auto;
  }

  #mitsumori-syo {
    min-width : 600px;
  }

  #mitsumori-title {
    width          : 100%;
    font-size      : 32px;
    line-height    : 32px;
    letter-spacing : 2em;
    padding-left   : 2em;
    margin-bottom  : 32px;
  }

  #mitsumori-client-wrapper {
    width      : 100%;
    text-align : left;
  }

  #mitsumori-client {
    width         : fit-content;
    border-bottom : 1px #0B0B61 solid;
  }

  #mitsumori-name {
    display    : inline-block;
    text-align : center;
    width      : 160px;
  }

  #mitsumori-sama {
    display    : inline-block;
    text-align : center;
    width      : 32px;
  }

  #mitsumori-contact-wrapper {
    width : 100%;
  }

  #mitsumori-contact {
    width      : fit-content;
    text-align : left;
    float      : right;
  }

  #mitsumori-cost-wrapeer {
    margin     : 48px 0 32px 0;
    width      : 100%;
    text-align : left;
  }

  #mitsumori-cost-table {
    width  : fit-content;
    border : 2px #0B0B61 solid;
  }

  #mitsumori-cost-title {
    padding      : 0 16px;
    font-weight  : bold;
    border-right : 2px #0B0B61 solid;
  }

  #mitsumori-cost {
    padding-left : 32px;
  }

  #mitsumori-table {
    width         : 100%;
    border        : 2px #0B0B61 solid;
    margin-bottom : 32px;
  }

  #mitsumori-table th {
    border              : 1px solid #0B0B61;
    border-bottom-width : 2px;
  }

  #mitsumori-table tr:nth-child(2n+1) {
    background : #F2FCFF;
  }

  #mitsumori-table tr:nth-child(1) {
    background : #EAF2FF;
  }

  #mitsumori-table tr:nth-last-child(1) {
    background : #EAF2FF;
  }

  #mitsumori-table td {
    border     : 1px #0B0B61 solid;
    padding    : 4px;
    text-align : left;
    height     : 30px;
  }

  .mitsumori-kei {
    font-weight   : bold;
    text-align    : right !important;
    padding-right : 32px !important;
  }
</style>

<style>
  .md-select-content {
    width : 30% !important;
  }

  .mitsumori-syo-small-text {
    font-size : 12px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Souzoku.vue